module.exports = __webpack_public_path__ + "img/applet-qr-code.25a28e7b.png";